import ReplyOmitted from './reply_omitted';

class ReplyCollapse {
  constructor(targetSelector, rootSelector = document) {
    this.root = rootSelector;
    this.init(targetSelector);
  }

  init(targetSelector) {
    const targets = this.root.querySelectorAll(targetSelector);

    targets.forEach((target) => {
      const button = target.querySelector(target.dataset.jsCollapseButtonSelector);
      const collapsedArea = target.querySelector(target.dataset.jsCollapseSelector);
      const isSpecified = target.dataset.jsCollapseIsSpecified === 'true';

      if (!target || !button || !collapsedArea) return;

      if (isSpecified) {
        this.expandArea(collapsedArea, button, target);
      } else {
        button.addEventListener('click', () => {
          this.expandArea(collapsedArea, button, target);
        });
      }
    });
  }

  expandArea(collapsedArea, button, target) {
    // FIXME: 該当classのdisplayプロパティを削除し　、hidden に置き換え出来た場合に `remove('hidden');` が不要になる
    collapsedArea.classList.remove('hidden');
    collapsedArea.classList.add('block');
    button.remove();
    new ReplyOmitted('.js-reply-omitted', target);
  }
}

export default ReplyCollapse;
